'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  margin-right: 10px;\n  ', ';\n'], ['\n  margin-right: 10px;\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n          position: absolute;\n          top: 50%;\n          transform: translateY(-50%);\n          right: 10px;\n          margin-right: 0px;\n        '], ['\n          position: absolute;\n          top: 50%;\n          transform: translateY(-50%);\n          right: 10px;\n          margin-right: 0px;\n        ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 40px;\n  line-height: 40px;\n  position: relative;\n  padding: ', ';\n  font-size: 14px;\n  border-style: none none none solid;\n  border-width: 2px;\n  border-color: transparent;\n  cursor: pointer;\n  color: ', ';\n  font-weight: ', ';\n\n  &:hover {\n    background: ', ';\n    border-color: ', ';\n    font-weight: 400;\n  }\n'], ['\n  width: 100%;\n  height: 40px;\n  line-height: 40px;\n  position: relative;\n  padding: ', ';\n  font-size: 14px;\n  border-style: none none none solid;\n  border-width: 2px;\n  border-color: transparent;\n  cursor: pointer;\n  color: ', ';\n  font-weight: ', ';\n\n  &:hover {\n    background: ', ';\n    border-color: ', ';\n    font-weight: 400;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Icon = require('../../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Components
// Styles


var MenuItemIcon = (0, _styledComponents2.default)(_Icon2.default)(_templateObject, function (_ref) {
  var arrow = _ref.arrow;
  return arrow ? (0, _styledComponents.css)(_templateObject2) : '';
});

var MenuItemHeader = function MenuItemHeader(_ref2) {
  var className = _ref2.className,
      icon = _ref2.icon,
      label = _ref2.label,
      open = _ref2.open,
      onClick = _ref2.onClick,
      arrow = _ref2.arrow,
      level = _ref2.level;
  return _react2.default.createElement('div', {
    className: className,
    onClick: onClick
  }, icon && _react2.default.createElement(MenuItemIcon, {
    icon: icon
  }), label, arrow && _react2.default.createElement(MenuItemIcon, {
    icon: open ? 'up' : 'down',
    arrow: true
  }));
};

MenuItemHeader.propTypes = {
  className: _propTypes2.default.string,
  icon: _propTypes2.default.string,
  label: _propTypes2.default.string,
  open: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  arrow: _propTypes2.default.bool,
  level: _propTypes2.default.number
};
var StyledMenuItemHeader = (0, _styledComponents2.default)(MenuItemHeader)(_templateObject3, function (_ref3) {
  var level = _ref3.level;
  return '0px 32px 0px ' + ((level - 1) * 30 + 10) + 'px';
}, function (_ref4) {
  var arrow = _ref4.arrow,
      level = _ref4.level;
  return arrow && level > 1 ? _colors.darkGrey : _colors.black;
}, function (_ref5) {
  var arrow = _ref5.arrow,
      level = _ref5.level;
  return !arrow && level > 1 ? 300 : 400;
}, function (_ref6) {
  var arrow = _ref6.arrow;
  return arrow ? 'none' : _colors.grey;
}, _colors.red);
exports.default = StyledMenuItemHeader;